import * as React from 'react';
import { colors } from '../../../index';

const IconUser = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 71 71",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 27.659,
    r: 12.778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 35.5C0 55.106 15.894 71 35.5 71S71 55.106 71 35.5C70.977 15.904 55.096.023 35.5 0 15.894 0 0 15.894 0 35.5zm59.516 19.674c-1.527-5.51-7.662-9.943-15.884-11.948a12.458 12.458 0 01-16.264 0c-8.227 1.806-14.364 6.387-15.886 11.943-10.378-12.653-9.16-31.187 2.785-42.373 11.945-11.185 30.52-11.185 42.464 0 11.945 11.186 13.163 29.72 2.785 42.373v.005z"
  }));
};

export default IconUser;